import { Component } from '@angular/core';
import { LoginService } from '../app/login.service';
import { ExamDiagnosesService } from './exam-diagnoses/exam-diagnoses.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'Aweb';
  constructor(
    private loginS: LoginService,
    // injected only so it exists from boot: it fetches the diagnoses catalogue on
    // onLogin, which fires long before any exam page is opened
    private diagnosesS: ExamDiagnosesService,
    translate: TranslateService
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en-US');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('he-IL');
  }
}
